import { render } from "./VideoBlock.vue?vue&type=template&id=6e8db93a&scoped=true&ts=true"
import script from "./VideoBlock.vue?vue&type=script&lang=ts"
export * from "./VideoBlock.vue?vue&type=script&lang=ts"

import "./VideoBlock.vue?vue&type=style&index=0&id=6e8db93a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8db93a"]])

export default __exports__